import { createAsyncThunk } from "@reduxjs/toolkit";
import * as PasswordApi from "../../../api/passwordApi";
import { trackEvent } from "../../../utils/tracking";
import { TRACKING_EVENTS } from "../../../utils/trackingDefinitions";

export const resetPassword = createAsyncThunk(
	"password/resetPassword",
	async ({
		username,
		nonce,
		password,
	}: {
		username: string;
		nonce: string;
		password: string;
	}) => {
		try {
			const response = await PasswordApi.resetPassword({
				username,
				nonce,
				password,
			});

			if (response.isSuccess) {
				trackEvent({
					event: TRACKING_EVENTS.PASSWORD.EVENT.USER_INTERACTION,
					target: TRACKING_EVENTS.PASSWORD.APP,
					key: "action",
					value: TRACKING_EVENTS.PASSWORD.EVENT.RESET_PASSWORD_TRIGGERED,
				});

				window.location.href = response.returnUrl;
			}

			return {
				isSuccess: response.isSuccess,
				error: response.isPasswordInvalid
					? response.errors?.[0]
					: "komid.resetpassword.fail.message",
				result: response,
			};
		} catch (error) {
			return { error: "komid.general.network.error" };
		}
	},
);

export const forgotPassword = createAsyncThunk(
	"password/forgotPassword",
	async ({ username, returnUrl }: { username: string; returnUrl: string }) => {
		try {
			const response = await PasswordApi.forgotPassword({
				username,
				returnUrl,
			});

			if (response.isSuccess) {
				trackEvent({
					event: TRACKING_EVENTS.PASSWORD.EVENT.USER_INTERACTION,
					target: TRACKING_EVENTS.PASSWORD.APP,
					key: "action",
					value: TRACKING_EVENTS.PASSWORD.EVENT.FORGOT_PASSWORD_EMAIL_SENT,
				});

				window.location.href = response.returnUrl;
			}

			return {
				isSuccess: response.isSuccess,
				error: response.errors?.[0] || "komid.resetpassword.fail.message",
				result: response,
			};
		} catch (error) {
			return { error: "komid.general.network.error" };
		}
	},
);
